import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { MatSelectChange, MatSelectModule } from '@angular/material/select';
import { ListingVariationPublic } from '../../../../globalTypes/listings.types';
import { Base } from '../../component/wrapper/base-wrapper.component';
import { FormsModule } from '@angular/forms';
import { FormInputNumberComponent } from "../../component/forms/form-input-number.component";
import { SelectImageComponent } from "../../component/image/select-image.component";
import { Logger } from '../../helper/logger';
import { JsonPipe } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { ConfirmDeleteDialogComponent, ConfirmDeleteDialogData } from '../../helper/confirm.delete.dialog';
import { MatDialog } from '@angular/material/dialog';
import { lastValueFrom, take } from 'rxjs';
import { DigitalFolderPublic } from '../../../../globalTypes/file.types';
import { LimiterDirective } from '../../directive/limiter';
const log = new Logger('PriceStockVariationComponent');

@Component({
  selector: 'msh-price-stock-variation',
  imports: [FormsModule, MatSelectModule, MatIconModule, FormInputNumberComponent, SelectImageComponent, LimiterDirective],
  template: `

  @if(!isOnlyVariation){
    <!-- TODO: Add image upload option here -->
    <div class="mb-4 opacity-50 font-light relative flex justify-between">
      Select an image to represent this variation
      <div class="flex gap-1">
        @if(totalVariations > 1){
          <mat-icon class=" cursor-pointer opacity-50 hover:opacity-100" (click)="deleteVariation()">delete</mat-icon>
        }
      </div>
    </div>

    <msh-select-image
      class="mb-7 block"
      [images]="images"
      [selectedId]="v.image && v.image.id ? v.image.id : undefined"
      (selectedIdChange)="onSelectId($event)"
    ></msh-select-image>
    <div>
      <input
        type="text"
        placeholder="Variation distinction name"
        [(ngModel)]="v.name"
        (change)="nameChange($event)"
        [limiter]="150"
        name="name"
        required
      />
    </div>
    <div>
      <input
        type="text"
        placeholder="Variation description"
        [(ngModel)]="v.description"
        (change)="descriptionChange($event)"
        [limiter]="10000"
        name="name"
        required
      />
    </div>
    @if(isDigital){
      @if(selectableFolders.length > 0){
        <mat-form-field appearance="fill" class="w-full mb-4 bg-back ">
          <mat-label>Limit content to</mat-label>
          <mat-select [(ngModel)]="folderIds" multiple (selectionChange)="onSelectFolder($event)">
            @for(folder of selectableFolders; track folder.id){
              <mat-option [value]="folder.id">{{folder.folderName}}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      } @else {
        <div class="null">No folders to limit content to</div>
      }
    }
  }

  <msh-form-input-number
    [price]="price"
    [placeholder]="'Price'"
    [limiterValue]="100000"
    (onImmediatePriceChange)="priceChange($event)"
  ></msh-form-input-number>
  @if(!isDigital){
    <div>
      <input
        type="number"
        placeholder="Stock"
        min="0"
        [maxValue]="10000"
        limiter
        [(ngModel)]="v.quantity"
        (ngModelChange)="quantityChange($event)"
        name="quantity"
        required
      />
    </div>
  }
  `,
  styles: ``
})
export class PriceStockVariationComponent extends Base<PriceStockVariationComponent> implements OnChanges {
  @Input() isOnlyVariation = true;
  @Input() images: {sortOrder: number, image:any} [] = [];
  @Input() totalVariations = 0;
  @Input() isDigital: boolean = false;
  @Input() v!: Partial<ListingVariationPublic>;
  @Output() onVariantChange: EventEmitter<Partial<ListingVariationPublic>> = new EventEmitter<Partial<ListingVariationPublic>>();
  @Output() onDelete: EventEmitter<void> = new EventEmitter<void>();
  price?: number
  displayPrice?: string
  @Input() selectableFolders: DigitalFolderPublic[] = [];
  folderIds: string[] = [];

  constructor(
    private dialog: MatDialog,
  ){ super()}

  ngOnInit(){
    log.log({img: this.v.image , v: this.v, priceInCents: this.v.priceInCents})
    if(this.v.priceInCents) this.price = this.v.priceInCents / 100;
    if(!this.v.image && this.images.length){
      this.v.image = this.images[0].image;
    }
  }
  ngOnChanges(changes: any): void {
    log.log({changes, v: this.v})
    if(changes['v']){
      this.price = this.v.priceInCents ? this.v.priceInCents / 100 : undefined;
      log.log({price: this.price})
      this.folderIds = this.v.digitalFolderListingVariations_on_listingVariation?.map(dflv => dflv.digitalFolderId) || [];
    }
  }

  priceChange(price: number){
    console.log({price})
    this.v.priceInCents = price * 100;
    this.onVariantChange.emit(this.v);
  }

  quantityChange(ev: any){
    console.log({quantity: this.v.quantity})
    this.onVariantChange.emit(this.v);
  }

  nameChange(ev: any){
    console.log({nameChange: this.v.name})
    this.onVariantChange.emit(this.v);
  }

  descriptionChange(ev: any){
    this.onVariantChange.emit(this.v);
  }

  onSelectId(id: string){
    log.log({id})
    this.v.image = this.images.find(i => i.image.id === id)?.image;
    log.log({image: this.v.image})
    this.onVariantChange.emit(this.v);
  }

  onSelectFolder(event: MatSelectChange<string[]>){
    const folderIds = event.value;
    const folders = this.selectableFolders.filter(folder => folderIds.includes(folder.id));
    log.log({folders})
    this.folderIds = folderIds;
    if(!this.v.digitalFolderListingVariations_on_listingVariation) this.v.digitalFolderListingVariations_on_listingVariation = [];
    this.v.digitalFolderListingVariations_on_listingVariation = folders.map((folder, idx) => ({digitalFolderId: folder.id, displayOrder: idx}));
    log.log({v: this.v})
    this.onVariantChange.emit(this.v);
  }

  async deleteVariation(){
    const data: ConfirmDeleteDialogData = {
      action: "Delete",
      item: "Variation",
      info: ["Are you sure you want","to delete this variation?","Name: "+this.v.name,"Description: "+this.v.description],
      class: '',
    }
    const dialog = this.dialog.open(ConfirmDeleteDialogComponent, {data});
    const results = await lastValueFrom(dialog.afterClosed().pipe(take(1)))
    if(results){
      this.onDelete.emit();
    }
  }
}
